import React from "react";

import { useTranslation } from "react-i18next";
import {
	FrontendUserInfo,
    OrganizationInfo,
} from "node-library/dist/portal";
import OrganizationUserRow from "./organizationUserRow";

interface Props {
	users: Array<FrontendUserInfo>;
    organization: OrganizationInfo;

	removeUser: (organization:OrganizationInfo, user: FrontendUserInfo) => void;

	gotoOrganizationDetailsPage: (organization: OrganizationInfo) => void;

	setRemoveUserModalConfirmOpen: React.Dispatch<React.SetStateAction<boolean>>;
	setProceedAction: React.Dispatch<React.SetStateAction<() => void>>;
}

export default function ViewOrganizationUsersList(props: Props) {
	const { t: translation } = useTranslation();

	const {
		users,
        organization,
		removeUser,
		gotoOrganizationDetailsPage,
		setRemoveUserModalConfirmOpen,
		setProceedAction,
	} = props;


	const organizationUserRows: Array<React.ReactNode> = users
		? users.map((user: FrontendUserInfo, index: number) => {
				return (
					<OrganizationUserRow
						key={user.userName}
						user={user}
                        organization={organization}
						removeUser={() => {
							setProceedAction(() => () => removeUser(organization, user));
							setRemoveUserModalConfirmOpen(true);
						}}
					/>
				);
		  })
		: [];

    const isScrollable: boolean = (organizationUserRows.length > 5);
	const sampleRowContainer: React.ReactNode = (
		<div className="organization-users-container" 
        style={{
            maxHeight: isScrollable ? "800px" : "auto",
            overflowY: isScrollable ? "auto" : "visible",
          }}
        >{organizationUserRows}</div>
	);

	return (
		<div>
			{sampleRowContainer}
		</div>
	);
}
